/**
 * @file コンポーネント：執刀医リスト スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledSurgeonlist = styled.ul`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px -8px 0;
`;

export const StyledSurgeonlistItem = styled.li`
    display: inline-flex;
    margin: 0 8px 8px 0;
`;
